/* global Blockly */
import React from 'react';
import PropTypes from 'prop-types';
import {fileuploadIcon} from "./index";

function defineBlock(context) {
    return {
        init: function () {
            this.appendDummyInput()
                .appendField("get ")
                .appendField(new Blockly.FieldDropdownSearch([["base64", "path"], ["filename", "fullname"], ["size", "size"], ["extension", "extension"]], undefined, undefined), "PROPERTY")
                .appendField(" of ")
                .appendField(new Blockly.FieldDropdown([["first uploaded file", "first"], ["last uploaded file", "last"]], undefined, undefined), "ALLFIRST")
                .appendField(" from")
                .appendField(new Blockly.FieldImage(fileuploadIcon, 30, 30, "fileupload icon", null), 'fileuploadIcon')
                .appendField(new Blockly.FieldWidgetsDropdown(context, "fileupload", undefined, '- select -'), "ID")

            this.setPreviousStatement(false);
            this.setNextStatement(false);
            this.setOutput(true, ["String"]);
            this.setOutputShape(Blockly.OUTPUT_SHAPE_ROUND);
            this.setColour(Blockly.Msg.WIDGET_VALUES_HUE);
            this.setTooltip(function() {
                let property = this.getFieldValue('PROPERTY');
                let propertyText = property == "fullname" ? "filename" : property;
                return `Get the ${propertyText} of the first uploaded file for file upload widget`;
            }.bind(this));
            this.setHelpUrl(Blockly.BASE_HELP_URL + '#file-uploads');
        },

        onchange: function() {
           if (this.getField('fileuploadIcon')?.imageElement_) {
               this.getField('fileuploadIcon').setTooltip('FileUpload control');
           }
        }
    }
}

function defineGenerators() {
    return {
        'JavaScript': function(block){
            let id = block.getFieldValue('ID');
            let property = block.getFieldValue('PROPERTY');
            let method = block.getFieldValue('ALLFIRST') == "last" ? "getLastUploadedItem" : "getFirstUploadedItem";
            let code = `(function () {
                var uploadedItems = Snap.widgets.fileupload.${method}("${id}");
                if (uploadedItems.length)
                    return uploadedItems.map(function (file) {return file.${property};})[0];
                return "";
            })()`;
            return [code, Blockly.JavaScript.ORDER_NONE];
        }
    }
}

const GetUploadedValue = function (props) {
    const name = 'snap_get_uploaded_value';
    GetUploadedValue.blockName = name;

    Blockly.Blocks[name] = defineBlock(props.context);
    let generators = defineGenerators();
    for (let i in generators) {
        Blockly[i][name] = generators[i];
    }

    if (props.widgets.length < 1) {
        return null;
    }

    return (
        <block type={name}>
            {props.widget?.id ? <field name='ID'>{props.widget.id}</field> : null}
        </block>
    );
}

GetUploadedValue.propTypes = {
    context: PropTypes.object.isRequired,
    widgets: PropTypes.array.isRequired,
    widget: PropTypes.object,
};

export default GetUploadedValue;
